import React, {Component} from 'react';
import {Col, Grid, Row,} from "react-bootstrap";
import {isMobile, isTablet} from "react-device-detect";
import PropTypes from 'prop-types';
import Empty from "../empty";

const FLAG_SIZE = 15;
const FLAG_SPACE = 10;
const OFFSET = 12.5;
const ANIMALS = [
    require("../../images/3_badger.png"),
    require("../../images/3_owl.png"),
    require("../../images/3_walrus.png"),
];

export default class App extends Component {

    static contextTypes = {
        preloaderContentLoaded: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {flags: [], animal: Math.round(Math.random() * 2), mask: false, mobileHeaderAnimation: false};
    }

    componentDidMount() {
        this.context.preloaderContentLoaded();
        window.addEventListener('resize', this.renderFlags.bind(this));
        this.renderFlags();
        setInterval(() => {
            this.setState({mask: true}, () => {
                setTimeout(() => {
                    this.setState({
                        animal: (this.state.animal + 1) % 3,
                        mobileHeaderAnimation: !this.state.mobileHeaderAnimation
                    }, () => {
                        setTimeout(() => {
                            this.setState({mask: false});
                        }, 250);
                    });
                }, 250);
            });
        }, 5000);
    }

    renderFlags() {
        if (!this.isNonDesktop()) {
            let height = (window.document.body.scrollHeight || window.innerHeight) - (2 * FLAG_SIZE);
            let width = (window.document.body.scrollWidth || window.innerWidth) - (2 * FLAG_SIZE);
            let verticalFlagAmount = Math.floor(height / (FLAG_SIZE + FLAG_SPACE));
            let verticalOverflow = height - ((verticalFlagAmount * (FLAG_SIZE + FLAG_SPACE)) - FLAG_SPACE + (2 * OFFSET));
            let horizontalFlagAmount = Math.floor(width / (FLAG_SIZE + FLAG_SPACE));
            let horizontalOverflow = width - ((horizontalFlagAmount * (FLAG_SIZE + FLAG_SPACE)) - FLAG_SPACE + (2 * OFFSET));
            let actualVerticalFlagSpace = (verticalOverflow / (verticalFlagAmount - 1)) + FLAG_SPACE;
            let actualHorizontalFlagSpace = (horizontalOverflow / (horizontalFlagAmount - 1)) + FLAG_SPACE;

            let flags = [];
            let flagTypeCounter = 0;

            for (let i = 0; i < horizontalFlagAmount; i++) {
                // TOP
                flags.push(
                    <div key={flagTypeCounter} style={{
                        top: OFFSET + FLAG_SIZE,
                        left: OFFSET + FLAG_SIZE + ((FLAG_SIZE + actualHorizontalFlagSpace) * i),
                    }} className={`flag _${flagTypeCounter % 6}`}/>
                );
                flagTypeCounter++;
            }

            for (let i = 0; i < verticalFlagAmount; i++) {
                if (i === 0 || i === (verticalFlagAmount - 1)) {
                    continue;
                }

                // RIGHT
                flags.push(
                    <div key={flagTypeCounter} style={{
                        left: -OFFSET + width,
                        top: OFFSET + FLAG_SIZE + ((FLAG_SIZE + actualVerticalFlagSpace) * i),
                    }} className={`flag _${flagTypeCounter % 6}`}/>
                );
                flagTypeCounter++;
            }

            for (let i = horizontalFlagAmount - 1; i >= 0; --i) {
                // BOTTOM
                flags.push(
                    <div key={flagTypeCounter} style={{
                        top: -OFFSET + height,
                        left: OFFSET + FLAG_SIZE + ((FLAG_SIZE + actualHorizontalFlagSpace) * i),
                    }} className={`flag _${flagTypeCounter % 6}`}/>
                );
                flagTypeCounter++;
            }

            for (let i = 0; i < verticalFlagAmount; i++) {
                if (i === 0 || i === (verticalFlagAmount - 1)) {
                    continue;
                }

                // LEFT
                flags.push(
                    <div key={flagTypeCounter} style={{
                        left: OFFSET + FLAG_SIZE,
                        bottom: OFFSET + FLAG_SIZE + ((FLAG_SIZE + actualVerticalFlagSpace) * i),
                    }} className={`flag _${flagTypeCounter % 6}`}/>
                );
                flagTypeCounter++;
            }

            this.setState({flags});
        }
    }

    isNonDesktop() {
        return isMobile || isTablet;
    }

    getColDef() {
        return this.isNonDesktop() ? {lg: 4} : {xs: 4};
    }

    render() {
        return (
            <Empty>
                {this.state.flags}
                <div id="container" className={!this.isNonDesktop() ? 'fixed' : 'not-fixed'}>
                    <div id="content">
                        <Grid fluid>
                            <Row>
                                <Col {...this.getColDef()}>
                                    <h4>
                                        <img id="wheel" src={require("../../images/steer.svg")}
                                             alt="We have a brand new office."/>ADVENTURE CLUB
                                    </h4>
                                </Col>
                                <Col {...this.getColDef()}>
                                </Col>
                                <Col {...this.getColDef()}>
                                    <h4>DESIGN STUDIO</h4>
                                </Col>
                            </Row>

                            <Row>
                                <Col {...this.getColDef()}>
                                    {!this.isNonDesktop() && <h3>AHOY!</h3>}

                                    {this.isNonDesktop() ? (
                                        <div>
                                            <div id="mask-mobile" className={`${this.state.mask ? 'closed' : 'open'}`}/>
                                            {!this.state.mobileHeaderAnimation ? (
                                                <h2 id="animated-header">We have a brand<br/>new office.</h2>
                                            ) : (
                                                <h2 id="animated-header">Come and take a<br/>look for yourself.</h2>
                                            )}
                                        </div>
                                    ) : (
                                        <h2>We have<br/>a brand<br/>new office.</h2>
                                    )}
                                    {!this.isNonDesktop() && <h3>FOOD.</h3>}
                                </Col>
                                <Col {...this.getColDef()}>
                                    <div id="center">
                                        <div>
                                            <img src={ANIMALS[this.state.animal]} alt="KALEVANKATU"/>
                                        </div>
                                        <div id="mask" className={`${this.state.mask ? 'closed' : 'open'}`}/>
                                        <div>
                                            <img style={{maxHeight: '80%'}}
                                                 src={require("../../images/kalevankatu.svg")} alt="KALEVANKATU"/>
                                        </div>
                                    </div>
                                </Col>
                                <Col {...this.getColDef()}>
                                    <h3>DRINKS.</h3>
                                    <h2>
                                        Come and <br/>
                                        take a look<br/>
                                        for yourself.
                                    </h2>
                                    <h3>FUTURE.</h3>
                                </Col>
                            </Row>

                            <Row>
                                <Col {...this.getColDef()}>
                                    <h4 className="reset-letter-spacing">KALEVANKATU 3 B 4–7 / HELSINKI</h4>
                                </Col>
                                {this.isNonDesktop() && (
                                    <Col {...this.getColDef()}>
                                        <h4 className="reset-letter-spacing">OCTOBER 4TH / 2018 / 03:00–11.30PM</h4>
                                    </Col>
                                )}
                                <Col {...this.getColDef()}>
                                    <div id="rsvp-here">
                                        <div className="stripe"/>
                                        <h3 style={{display: 'inline'}}>
                                            <a href="https://www.eventbrite.com/e/adventure-club-house-warming-party-tickets-49934787293">
                                                RSVP HERE
                                            </a>
                                        </h3>
                                        <div className="stripe"/>
                                    </div>
                                </Col>
                                {!this.isNonDesktop() && (
                                    <Col {...this.getColDef()}>
                                        <h4 className="reset-letter-spacing">OCTOBER 4TH / 2018 / 03:00–11.30PM</h4>
                                    </Col>
                                )}
                            </Row>
                        </Grid>
                    </div>
                </div>
            </Empty>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/app/index.js